import { UserAccessFeatureFlag, UserAccessRole, } from './user-access.types';
export { UserAccessFeatureFlag as MeiaStudioAccessFeatureFlag, UserAccessRole as MeiaStudioAccessRole, } from './user-access.types';
/**
 * Grants MEIA Studio access (AZ-451, D2): requires the INTELLIGENCE platform role, then the selected
 * Intelligence Organization's `MEIA_STUDIO_V1` flag (org-first) OR the user-level flag (rollout
 * fallback). `organization` is optional — when omitted, only the user-level flag is consulted, so
 * existing call sites keep working until they pass the selected-org context.
 *
 * MEIA_STUDIO_V2 is deprecated and intentionally not honored here; only MEIA_STUDIO_V1 grants access.
 */
export function hasMeiaStudioCampaignAccess(params) {
    const { featureFlags, organization, role } = params;
    if (role !== UserAccessRole.INTELLIGENCE) {
        return false;
    }
    const orgGrantsAccess = Boolean(organization?.isIntelligenceOrganization &&
        organization.featureFlags?.includes(UserAccessFeatureFlag.MEIA_STUDIO_V1));
    const userFlagGrantsAccess = Boolean(featureFlags?.includes(UserAccessFeatureFlag.MEIA_STUDIO_V1));
    return orgGrantsAccess || userFlagGrantsAccess;
}
